import {
  Card,
  CardContent,
  CardActions,
  Stack,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Divider,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { ExpandLess } from "@mui/icons-material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useIsDesktop } from "../../../utils/Functions";

export default function PetNoteListItem({
  note,
  canUserAddOrRemoveNotes,
  handleDelete,
}) {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();
  const isDesktop = useIsDesktop();

  if (!note) return null;
  return (
    <Card
      variant="outlined"
      sx={{ borderRadius: 3, borderColor: "divider", minWidth: 0 }}
      key={note?.id}
      data-testid={`pet.notes.list-item.${note.id}`}
    >
      <CardContent>
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography
            variant="subtitle1"
            color="textSecondary"
            sx={{ mb: 2 }}
            data-testid={`pet.notes.creator-name.${note.id}`}
          >
            {note.creatorFullName ? note.creatorFullName : t("PetDeceasedNote")}
          </Typography>
          <Stack direction="row">
            <Typography
              variant="subtitle2"
              color="textSecondary"
              sx={{ mr: 2 }}
              data-testid={`pet.notes.date.${note.id}`}
            >
              {note.date}
            </Typography>
            {canUserAddOrRemoveNotes && (
              <Tooltip
                title={t("DeleteNote")}
                sx={{ position: "relative", bottom: 10, right: 10 }}
              >
                <IconButton
                  onClick={() => handleDelete(note.id)}
                  color="error"
                  data-testid={`pet.notes.delete-button.${note.id}`}
                >
                  <DeleteIcon />
                </IconButton>
              </Tooltip>
            )}
          </Stack>
        </Stack>

        <Divider sx={{ mb: 2 }} />

        <Box
          style={{
            maxHeight: expanded ? "500px" : "100px",
            overflowY: expanded ? "auto" : "clip",
            overflowX: "hidden",
            position: "relative",
            transition: "max-height 0.4s ease",
          }}
        >
          <Typography
            variant="body1"
            lineHeight={1.65}
            sx={{
              whiteSpace: "pre-line",
              overflowWrap: "break-word",
            }}
            data-testid={`pet.notes.description.${note.id}`}
          >
            {note.description}
          </Typography>
        </Box>
      </CardContent>
      <CardActions>
        {isDesktop ? null : (
          <IconButton onClick={() => setExpanded(!expanded)}>
            {!expanded ? (
              <Tooltip title={t("ShowMore")}>
                <ExpandMoreIcon />
              </Tooltip>
            ) : (
              <Tooltip title={t("ShowLess")}>
                <ExpandLess />
              </Tooltip>
            )}
          </IconButton>
        )}
      </CardActions>
    </Card>
  );
}
